var n = function() {
  var a = "", r, i;
  for (r = 0; r < 32; r++)
    i = Math.random() * 16 | 0, (r === 8 || r === 12 || r === 16 || r === 20) && (a += "-"), a += (r === 12 ? 4 : r === 16 ? i & 3 | 8 : i).toString(16);
  return a;
};
export {
  n as g
};
